var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAgents(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;stroke:#707070;opacity:0;}.b{fill:#3f51b5;}.c{stroke:none;}.d{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-333 -306)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(333 306)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(335 277.992)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M18.681,35.807H17.443a7.805,7.805,0,0,0-14.4,0H1.8a1.8,1.8,0,0,0-1.8,1.8v2.4a1.8,1.8,0,0,0,1.8,1.8H4.258L4,41.021a6.615,6.615,0,1,1,6.248,4.387,1.8,1.8,0,1,0,1.791,1.8V46.4a7.831,7.831,0,0,0,5.4-4.59h1.24a1.8,1.8,0,0,0,1.8-1.8v-2.4a1.8,1.8,0,0,0-1.8-1.8Zm-16.038,4.8H1.8a.6.6,0,0,1-.6-.6v-2.4a.6.6,0,0,1,.6-.6h.85q-.032.135-.059.271A7.919,7.919,0,0,0,2.643,40.607Zm8.2,6.6a.6.6,0,0,1-1.2,0,.607.607,0,0,1,.611-.6q.3,0,.589-.023Zm8.44-7.2a.6.6,0,0,1-.6.6h-.85a7.858,7.858,0,0,0,.107-3.08q-.042-.261-.1-.52h.846a.6.6,0,0,1,.6.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M181,210.993h1.2v1.2H181Z",
    transform: "translate(-173.76 -172.786)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M241,210.993h1.2v1.2H241Z",
    transform: "translate(-231.36 -172.786)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M301,210.993h1.2v1.2H301Z",
    transform: "translate(-288.96 -172.786)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M121,100.593v1.2h5.4a5.4,5.4,0,1,0-4.247-2.065A1.193,1.193,0,0,1,121,100.593Zm5.4-8.4a4.2,4.2,0,0,1,0,8.4h-3.321a2.39,2.39,0,0,0,.311-.979l.024-.257-.17-.194a4.2,4.2,0,0,1,3.157-6.971Z",
    transform: "translate(-116.16 -57.586)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgents);
export default __webpack_public_path__ + "static/media/agents.ab6e47d381b9819683e0b77893192e2e.svg";
export { ForwardRef as ReactComponent };